module.exports = __webpack_public_path__ + "img/match-schedule-symbol.942d6f84.svg";